import React from "react";

/**
 * Fixes special font glyph issues (e.g., in Proxima demo fonts)
 * by forcing normal "-" and spaces to render in a neutral font.
 *
 * Usage:
 *   renderTextWithSafeDashes("State-of-the-art Exams")
 */
export const renderTextWithNormalDash = (text) => {
  if (!text || typeof text !== "string") return text;

  // Match any special character OR the number 4
  return text.split(/([^\w\s]|4)/g).map((part, i) => {
    if (/([^\w\s]|4)/.test(part)) {
      return (
        <span key={i} className="safe-char">
          {part}
        </span>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};

